module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.developerPageModel.retrievedInformation) ? _c('section', {
    ref: "echo",
    attrs: {
      "id": "developer-companion-content"
    }
  }, [_c('div', {
    staticClass: "main-details"
  }, [_c('div', {
    staticClass: "avatar-container"
  }, [_c('avatar', {
    attrs: {
      "profile-data": _vm.developer,
      "profile-type": "developer",
      "size": "super-large",
      "show-xp-info": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "details-container"
  }, [(_vm.developer.siteModCanBan || _vm.developer.donatedAmount > 0 || _vm.developer.isBanned) ? _c('div', {
    staticClass: "special-developer-banners"
  }, [(_vm.developer.siteModCanBan) ? _c('div', {
    staticClass: "special-developer-banner"
  }, [_c('i', {
    staticClass: "fas fa-crown mod-icon"
  }), _vm._v(" Site Moderator\n                ")]) : _vm._e(), _vm._v(" "), (_vm.developer.donatedAmount > 0 && _vm.developer.donatedAmount < 40) ? _c('div', {
    staticClass: "special-developer-banner"
  }, [_c('i', {
    staticClass: "fas fa-heartbeat donor-icon"
  }), _vm._v(" Develteam Supporter\n                ")]) : _vm._e(), _vm._v(" "), (_vm.developer.donatedAmount >= 40) ? _c('div', {
    staticClass: "special-developer-banner"
  }, [_c('i', {
    staticClass: "fas fa-heartbeat donor-icon  gold"
  }), _vm._v(" Develteam Supporter\n                ")]) : _vm._e(), _vm._v(" "), (_vm.developer.isBanned) ? _c('div', {
    staticClass: "special-developer-banner"
  }, [_c('i', {
    staticClass: "fas fa-skull banned-icon"
  }), _vm._v(" BANNED\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "dev-alias"
  }, [_c('i', {
    class: [{
      'fas fa-user': true,
      'online': _vm.developerIsOnline
    }]
  }), _vm._v(_vm._s(_vm.developer.alias) + "\n            ")]), _vm._v(" "), (_vm.developerIsOnline) ? _c('div', {
    staticClass: "last-online"
  }, [_c('i', {
    staticClass: "fa fa-circle online"
  }), _vm._v(" Online")]) : _vm._e(), _vm._v(" "), (!_vm.developerIsOnline) ? _c('div', {
    staticClass: "last-online"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" Offline (" + _vm._s(_vm._f("formatDate")(_vm.developer.lastOnline)) + ")")]) : _vm._e(), _vm._v(" "), (_vm.showBasicInfo) ? _c('ul', {
    staticClass: "basic-info"
  }, [(_vm.developerFullName !== '') ? _c('li', [_vm._v(_vm._s(_vm.developerFullName))]) : _vm._e(), _vm._v(" "), (_vm.developerBasicDetails !== '') ? _c('li', [_vm._v(_vm._s(_vm.developerBasicDetails))]) : _vm._e(), _vm._v(" "), (_vm.developer.location) ? _c('li', [_vm._v(_vm._s(_vm.developer.location))]) : _vm._e(), _vm._v(" "), (_vm.developer.role) ? _c('li', [_vm._v(_vm._s(_vm.developer.role))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showContactOptions) ? _c('div', {
    staticClass: "connect-options"
  }, [_c('span', {
    on: {
      "click": _vm.sendMail
    }
  }, [_c('i', {
    staticClass: "far fa-envelope"
  }), _vm._v(" Mail")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.openConversation
    }
  }, [_c('i', {
    staticClass: "far fa-comment-alt"
  }), _vm._v(" Chat")]), _vm._v(" "), (_vm.showInviteOption) ? _c('span', {
    on: {
      "click": _vm.sendInvite
    }
  }, [_c('i', {
    staticClass: "fas fa-gamepad"
  }), _vm._v(" Invite")]) : _vm._e(), _vm._v(" "), (!_vm.isFollowing && _vm.showFollowOption && !_vm.savingFollowingChange) ? _c('span', {
    on: {
      "click": _vm.updateFollowStatus
    }
  }, [_c('i', {
    staticClass: "far fa-paper-plane"
  }), _vm._v(" Follow")]) : _vm._e(), _vm._v(" "), (_vm.isFollowing && _vm.showFollowOption && !_vm.savingFollowingChange) ? _c('span', {
    on: {
      "click": _vm.updateFollowStatus
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v(" Un follow")]) : _vm._e(), _vm._v(" "), (_vm.savingFollowingChange) ? _c('span', [_c('i', {
    staticClass: "fas fa-sync fa-spin"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.developer.lookingForGame) ? _c('div', {
    staticClass: "wants-to-collab"
  }, [_c('div', {
    staticClass: "badge"
  }, [_vm._v("Wants to join a Game Project")]), _vm._v(" "), (_vm.developer.lookingForDescription) ? _c('div', {
    staticClass: "description"
  }, [_c('h3', [_vm._v("What I'm looking for in a team")]), _vm._v("\n                    " + _vm._s(_vm.developer.lookingForDescription) + "\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showRoleTags && _vm.roleSkillListMode === 'display') ? _c('div', {
    staticClass: "roles"
  }, [_c('h3', [_vm._v("\n                    Roles\n                    "), (_vm.isSelf) ? _c('i', {
    staticClass: "fas fa-pencil-alt edit-icon",
    on: {
      "click": function($event) {
        _vm.toggleEditRolesSkills()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "role-list"
  }, [(_vm.developer.isProducer) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=producers'
    }
  }, [_c('span', [_vm._v("Producer")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isDesigner) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=designers'
    }
  }, [_c('span', [_vm._v("Designer")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isArtist) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=artists'
    }
  }, [_c('span', [_vm._v("Artist")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isProgrammer) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=programmers'
    }
  }, [_c('span', [_vm._v("Programmer")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isWriter) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=writers'
    }
  }, [_c('span', [_vm._v("Writer")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isMusician) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=musicians'
    }
  }, [_c('span', [_vm._v("Musician")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isSfxArtist) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=sfx'
    }
  }, [_c('span', [_vm._v("SFX Artist")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isTester) ? _c('router-link', {
    staticClass: "role-tag",
    attrs: {
      "to": '/Browse/Developers?seekingRole=testers'
    }
  }, [_c('span', [_vm._v("Tester")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.showSkillTags && _vm.roleSkillListMode === 'display') ? _c('div', {
    staticClass: "skills"
  }, [_c('h3', [_vm._v("\n                    Skills\n                    "), (_vm.isSelf) ? _c('i', {
    staticClass: "fas fa-pencil-alt edit-icon",
    on: {
      "click": function($event) {
        _vm.toggleEditRolesSkills()
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.roleSkillListMode === 'display' && _vm.developer.skills) ? _c('div', {
    staticClass: "skill-list"
  }, _vm._l((_vm.developer.skills), function(skillId) {
    return _c('router-link', {
      staticClass: "skill-tag",
      attrs: {
        "to": '/Browse/Developers?seekingSkill=' + skillId
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.getSkill(skillId)) + "\n                    ")])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleSkillListMode === 'edit') ? _c('edit-roles-and-skills', {
    on: {
      "doneEditing": function($event) {
        _vm.roleSkillListMode = 'display'
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showGames || _vm.isSelf) ? _c('div', {
    staticClass: "game-projects companion-content-subsection"
  }, [_c('h3', [_vm._v(_vm._s(_vm.developer.alias) + "'s Game Projects")]), _vm._v(" "), _vm._l((_vm.developer.games), function(game) {
    return _c('router-link', {
      staticClass: "avatar-container",
      attrs: {
        "to": ("/Game/" + (game.stringUrl))
      }
    }, [_c('avatar', {
      attrs: {
        "profile-data": game,
        "profile-type": "game",
        "size": "large",
        "show-xp-info": false
      }
    }), _vm._v("\n\n                    " + _vm._s(game.alias) + "\n\n                ")], 1)
  }), _vm._v(" "), (_vm.isSelf) ? _c('router-link', {
    staticClass: "avatar-container",
    attrs: {
      "to": "/CreateNewGameProject"
    }
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('i', {
    staticClass: "fas fa-fw fa-plus"
  })]), _vm._v(" "), _c('span', [_vm._v("Create a New Game")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.showWebsites) ? _c('div', {
    staticClass: "websites companion-content-subsection"
  }, [_c('h3', [_vm._v("\n                    Websites\n                    "), (_vm.isSelf && _vm.websiteListMode === 'display') ? _c('i', {
    staticClass: "fas fa-pencil-alt edit-icon",
    on: {
      "click": function($event) {
        _vm.toggleEditWebsites()
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.websiteListMode === 'display') ? [_c('ul', {
    staticClass: "website-list"
  }, _vm._l((_vm.developer.personalWebsites), function(website) {
    return _c('li', [_c('a', {
      attrs: {
        "href": website.url,
        "target": "_blank"
      }
    }, [_c('i', {
      class: ['fa-fw', _vm.getLinkIcon(website.url)]
    }), _vm._v(" " + _vm._s(website.name) + "\n                            ")])])
  }))] : _vm._e(), _vm._v(" "), (_vm.websiteListMode === 'edit') ? _c('edit-websites', {
    on: {
      "doneEditing": function($event) {
        _vm.websiteListMode = 'display'
      }
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isSelf || Object.keys(_vm.developer.workHistory || []).length > 0) ? _c('div', {
    staticClass: "work-history"
  }, [_c('h3', [_vm._v("\n                    Work History\n                    "), (_vm.isSelf && _vm.workHistoryMode === 'display') ? _c('i', {
    staticClass: "fas fa-pencil-alt edit-icon",
    on: {
      "click": function($event) {
        _vm.toggleEditWorkHistory()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.developer.workHistory), function(workItem) {
    return (_vm.workHistoryMode === 'display') ? _c('ul', [_c('li', [_vm._v(_vm._s(workItem.place))]), _vm._v(" "), (workItem.title) ? _c('li', [_vm._v(_vm._s(workItem.title))]) : _vm._e(), _vm._v(" "), (workItem.start) ? _c('li', [_vm._v(_vm._s(workItem.start) + " "), (workItem.end) ? [_vm._v("- " + _vm._s(workItem.end))] : _vm._e()], 2) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.workHistoryMode === 'edit') ? _c('edit-work-history', {
    on: {
      "doneEditing": function($event) {
        _vm.workHistoryMode = 'display'
      }
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isSelf || Object.keys(_vm.developer.educationHistory || {}).length > 0) ? _c('div', {
    staticClass: "education-history"
  }, [_c('h3', [_vm._v("\n                    Education History\n                    "), (_vm.isSelf && _vm.educationMode === 'display') ? _c('i', {
    staticClass: "fas fa-pencil-alt edit-icon",
    on: {
      "click": function($event) {
        _vm.toggleEditEducation()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.developer.educationHistory), function(educationItem) {
    return (_vm.educationMode === 'display') ? _c('ul', [_c('li', [_vm._v(_vm._s(educationItem.place))]), _vm._v(" "), (educationItem.title) ? _c('li', [_vm._v(_vm._s(educationItem.title))]) : _vm._e(), _vm._v(" "), (educationItem.start) ? _c('li', [_vm._v(_vm._s(educationItem.start) + " "), (educationItem.end) ? [_vm._v("- " + _vm._s(educationItem.end))] : _vm._e()], 2) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.educationMode === 'edit') ? _c('edit-education-history', {
    on: {
      "doneEditing": function($event) {
        _vm.educationMode = 'display'
      }
    }
  }) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), (_vm.isSelf) ? _c('div', {
    staticClass: "edit-options"
  }, [(_vm.displayMode === 'normal') ? [_c('div', {
    staticClass: "upload-avatar"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "avatar",
      "accept": "image/jpeg, image/png"
    },
    on: {
      "change": _vm.updateUploadedAvatarName
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.displayMode = 'editAccountInformation'
      }
    }
  }, [_vm._v("Edit Account Settings")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.displayMode = 'editBasicDetails'
      }
    }
  }, [_vm._v("Edit Bio Details")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.displayMode = 'editNetworking'
      }
    }
  }, [_vm._v("Edit Networking Details")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.displayMode === 'editAccountInformation') ? _c('edit-account-info', {
    on: {
      "doneEditing": function($event) {
        _vm.displayMode = 'normal'
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayMode === 'editBasicDetails') ? _c('edit-basic-details', {
    on: {
      "doneEditing": function($event) {
        _vm.displayMode = 'normal'
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayMode === 'editNetworking') ? _c('edit-networking', {
    on: {
      "doneEditing": function($event) {
        _vm.displayMode = 'normal'
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayMode !== 'banDeveloper') ? [(_vm.canBan && !_vm.developer.isBanned) ? _c('button', {
    staticClass: "ban-button",
    on: {
      "click": function($event) {
        _vm.displayMode = 'banDeveloper'
      }
    }
  }, [_vm._v("\n                Ban " + _vm._s(_vm.developer.alias) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.canBan && _vm.developer.isBanned) ? _c('button', {
    staticClass: "ban-button",
    on: {
      "click": function($event) {
        _vm.displayMode = 'banDeveloper'
      }
    }
  }, [_vm._v("\n                Un-Ban " + _vm._s(_vm.developer.alias) + "\n            ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.displayMode === 'banDeveloper') ? _c('ban-developer', {
    on: {
      "doneEditing": function($event) {
        _vm.displayMode = 'normal'
      }
    }
  }) : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2807a9aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Developer/DeveloperDetails.vue
// module id = 840
// module chunks = 2